import { render } from "./RCSTemplateSettings.vue?vue&type=template&id=bdbbdbc2"
import script from "./RCSTemplateSettings.vue?vue&type=script&lang=js"
export * from "./RCSTemplateSettings.vue?vue&type=script&lang=js"

import exportComponent from "/workspace/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__